import * as _ from 'lodash';

angular.module("twshared").factory('personArchive', ['$uibModal', function ($uibModal) {

    var so = {};

    function showDialog(persons) {
        return $uibModal.open({
            animation: false,
            template: require('./personArchive.html'),
            controller: 'PersonArchiveController as $ctrl',
            windowClass: "modal fade in",
            size: 'md',
            resolve: {
                persons: function () { return persons; },
            }
        }).result;
    }

    so.archiveMultiple = function (persons) {
        return showDialog(persons);
    };

    so.archiveSingle = function (person) {
        return showDialog([person]);
    };

    return so;
}]);
